import { Grid, styled } from '@mui/material';

import Address from 'reservations/account/components/Address';
import PhoneNumber from 'reservations/account/components/PhoneNumber';
import TopMatter from 'reservations/account/components/TopMatter';
import { useLocation } from 'reservations/account/providers/ConfigProvider';

const StyledDetailsContainer = styled(Grid)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    alignItems: 'center',
    justifyContent: 'center'
  },
  alignItems: 'left',
  justifyContent: 'left'
}));

export const TopMatterWithDetails = () => {
  const { phone_number: phoneNumber, street } = useLocation();

  return (
    <TopMatter>
      <StyledDetailsContainer item container spacing="16px">
        <Grid item>
          <Address address={street} />
        </Grid>
        {phoneNumber && (
          <Grid item>
            <PhoneNumber phoneNumber={phoneNumber} />
          </Grid>
        )}
      </StyledDetailsContainer>
    </TopMatter>
  );
};
